<template>
    <div class="wrap" >
        <div class="header">友情链接</div>
        <div class="content">
            <ul>
                <li v-for="item in list">
                    <a :href="item.link" target="_blank">
                        {{item.title}}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .wrap{
        & .header{
            line-height: 30px;
            font-size: 16px;
            color: #666666;
            border-bottom: 1px solid #e4e4e4;
            padding: 0 8px;
        }
        & .content{
            margin: 8px;
            & ul{
                list-style: none;
                & li{
                    display: inline-block;
                    font-size: 14px;
                    padding: 4px 8px;
                    margin-right: 10px;

                    &:last-child{
                        margin-right: 0;
                    }
                }
            }
        }
    }
</style>
<script>
    export default {
        name:'v-friend-link',
        data() {
            return {
                list:[
                    {title:'上海云盾',link:'https://www.yundun.com'},
                    {title:'金山软件',link:'http://www.kingsoft.com'},
                    {title:'中科新业',link:'http://www.seentech.com.cn/'},
                    {title:'天域时捷',link:'http://www.digi-graphic.com/'},
                    {title:'天融信',link:'http://www.topsec.com.cn/'},
                    {title:'上海兴容',link:'http://www.sinsaa.org.cn/Manufacturers.aspx'},
                    {title:'上海信安',link:'http://www.infosafe.net.cn/'},
                    {title:'三零卫士',link:'http://www.30wish.net/'},
                    {title:'启明星辰',link:'http://www.venustech.com.cn/'},
                    {title:'绿盟科技',link:'http://www.nsfocus.com/'},
                    {title:'杭州安恒',link:'http://www.dbappsecurity.com.cn/'},
                    {title:'中软华泰',link:'http://www.sinsaa.org.cn/Manufacturers.aspx'},
                ]
            }
        },
        components: {}
    }
</script>
